export const languageModes = {
  en: "en",
  vi: "vi",
};
